module.exports = __webpack_public_path__ + "img/20180815_151146_115.875ff0b3.jpg";